import { EssentialStyling } from "@/apidtos";

export type TailwindPrefix = "pt"
  | "pr"
  | "pb"
  | "pl"
  | "mt"
  | "mr"
  | "mb"
  | "ml"
  | "rounded-tl"
  | "rounded-tr"
  | "rounded-bl"
  | "rounded-br"
  | "border-t"
  | "border-b"
  | "border-l"
  | "border-r"
  | "h"
  | "w"
  | "bg"
  | "top"
  | "right"
  | "bottom"
  | "left"
  | "leading";

export interface ThemeFullSections {
  BuyBlock: string[];
  CartGrid: string[];
  CartTotals: string[];
  Checkout: string[];
  CheckoutShipping: string[];
  CheckoutShippingRates: string[];
  CheckoutPayment: string[];
  Catalog: string[];
  CatalogFilterAccordion: string[];
  CVGrid: string[];
  Dashboard: string[];
  DashboardBreadcrumbs: string[];
  DashboardSidebar: string[];
  Footer: string[];
  Form: string[];
  Header: string[];
  RelatedProducts: string[];
  ProductDetails: string[];
  ProductDetailsNormal: string[];
  ProductDetailsDynamic: string[];
  ProductDetailsVariantTable: string[];
  ProductVariants: string[];
  Registration: string[];
  QuickAddToCart: string[];
}

export interface CSSUtilityMapping {
  cssProperty: keyof EssentialStyling;
  direction?: "Top" | "Right" | "Bottom" | "Left" | "TopLeft" | "TopRight" | "BottomLeft" | "BottomRight";
  prefix: string;
}

export const fullSections = {
  Catalog: [
    "Container",
    "Breadcrumbs",
    "FormPaginationContainer",
    "HeadInnerContainer",
    "FormatButton",
    "FormatButtonIcon",
    "SizeButton",
    "ProductCardImage",
    "MicroCart",
    "MicroCartLink",
    "MicroCartInnerContainer",
  ],
  CatalogFilterAccordion: [
    "AppliedFilterAccordion",
    "AppliedFilterAccordionItem",
    "AppliedFilterAccordionTrigger",
    "AppliedFilterAccordionTriggerIcon",
    "AppliedFilterAccordionContent",
    "AppliedFilterContainer",
    "ClearAppliedFiltersButtonContainer",
    "ClearAppliedFiltersButton",
    "FilterAccordion",
    "FilterAccordionItem",
    "FilterAccordionTrigger",
    "FilterCompareCartAccordionItem",
    "FilterCompareCartAccordionTrigger",
    "FilterCompareCartAccordionTriggerIcon",
    "FilterCompareCartAccordionContent",
    "FilterCompareCartAccordionRemoveItemsButton",
    "FilterCompareCartAccordionClearCartButton",
    "FilterAccordionContentContainer",
    "FilterAccordionContentSubmitButton",
    "FilterAccordionTriggerIcon",
    "KeyValueFilterCollapsibleContent",
    "BucketFilterList",
    "BucketFilterListButton",
    "FilterAccordionContentApplyButtonContainer",
  ],
  CVGrid: [
    "Table",
    "TableBody",
    "TableHeader",
    "TableHeaderRow",
    "TableHead",
    "TableRow",
    "TableData",
    "FilterContainer",
  ],
  Dashboard: [
    "OuterContainer",
    "SidebarInset",
    "TitleBlockHeading"
  ],
  DashboardBreadcrumbs: [
    "OuterContainer",
    "List",
    "ListItem",
    "ActiveLink",
    "InactiveLink"
  ],
  CartGrid: [
    "Table",
    "TableBody",
    "TableHeader",
    "TableHeaderRow",
    "TableHead",
    "TableRow",
    "TableData",
    "DeleteButton",
    "ShoppingCartTitle",
    "ProceedToCheckoutButton",
  ],
  CartTotals: [
    "Container",
    "Row"
  ],
  Checkout: [
    "Container",
    "StepContainer", 
    "StepInnerContainer",
    "StepLink",
    "StepTitle",
    "NextStepButtonContainer",
    "NextStepButton"
  ],
  CheckoutShipping: [
    "Container",
    "LabeledCheckboxContainer",
    "SingleShippingContainer",
    "SingleShippingLabel",
    "SingleShippingLabeledSelect",
    "AddressBlockContainer",
    "SplitShippingProductImage",
    "SplitShippingContainer",
    "SplitShippingProductName",
    "SplitShippingActionsContainer",
    "AddDestinationButton",
    "RemoveDestinationButton",
  ],
  CheckoutShippingRates: [
    "Container",
    "SubTitleContainer",
    "RateQuoteContainer",
    "ShipmentLabelContainer",
    "ProductSectionLabel",
    "FulfillmentLabelContainer",
    "FulfillmentProductName",
    "FulfillmentProductQuantity",
    "AddressSectionLabel",
    "AddressBlockContainer",
    "ShippingRateQuoteLabel",
    "Table",
    "TableHeader",
    "TableHeaderRow",
    "TableHeadSelectRow",
    "TableHead",
    "TableBody",
    "TableSelectCell",
    "TableCell",
  ],
  CheckoutPayment: [
    "Container",
    "CheckoutMethodSelectorContainer",
    "PaymentMethodSelectorContainer"
  ],
  DashboardSidebar: [
    "Button",
    "Link",
    "Icon",
    "Group",
    "Label",
    "Menu"
  ],
  Footer: [
    "OuterContainer",
    "InnerContainer",
    "MobileContainer",
    "MobileAccordionTrigger",
    "MobileAccordionContent",
    "MobileLink",
    "BlocksContainer",
    "BlockContainer",
    "BlockHeading",
    "BlockList",
    "CopyrightContainer",
  ],
  Form: [
    "Label",
    "TextInput",
    "CheckboxInput",
    "Icon",
  ],
  Header: [
    "OuterContainer",
    "InnerContainer",
    "LogoContainer",
    "Logo",
    "MiniMenuButton",
    "MiniMenuDropdownLabel",
    "MiniMenuItem",
    "MiniMenuItemLink",
    "HeaderTextSearchFilterInput",
    "HeaderTextSearchFilterButton",
    "HomepageTabs",
    "LanguageSelectorButton",
  ],
  ProductDetails: [
    "AttributeTabsContainer",
    "AttributeTabsList",
    "AttributeTabsTrigger",
    "BreadcrumbContainer",
    "BreadcrumbList",
    "BreadcrumbListItem",
    "BreadcrumbActive",
    "BreadcrumbInactive",
    "ImageCarousel",
    "Title",
  ],
  ProductDetailsNormal: [
    "PriceContainer",
    "SalePrice",
    "AppliedPrice",
    "PercentOff",
    "StockContainer",
    "StockText",
    "StockPurchaseable",
    "StockNonPurchaseable",
    "ShortDescriptionContainer",
    "ShortDescriptionTitle",
    "ShortDescription",
    "Sku",
  ],
  ProductDetailsDynamic: [
    "PriceContainer",
    "SalePrice",
    "AppliedPrice",
    "PercentOff",
    "StockContainer",
    "StockText",
    "StockPurchaseable",
    "StockNonPurchaseable",
    "ShortDescriptionContainer",
    "ShortDescriptionTitle",
    "ShortDescription",
    "Sku",
  ],
  ProductDetailsVariantTable: [
    "Table",
    "TableHeader",
    "TableHeaderRow",
    "TableHead",
    "TableBody",
    "TableBodyRow",
    "TableData"
  ],
  ProductVariants: [
    "Container",
    "OptionContainer",
    "OptionTitle",
    "Button",
    "ButtonSelected",
    "ButtonUnselected",
    "Title",
  ],
  RelatedProducts: [
    "Container",
    "Title",
    "PreviousButton",
    "NextButton"
  ],
  Registration: [
    "Container",
    "Heading",
    "Subheading",
    "SubmitButton",
    "ReturnButton",
  ],
  BuyBlock: [
    "AddToCartButton",
    "AddToStaticCartButton",
    "Container",
    "QuantitySelector",
    "QuantitySelectorContainer",
    "ViewDetailsButton",
  ],
  QuickAddToCart: [
    "CommandItem",
    "Container",
    "SelectedContainer",
    "SelectedTitle",
    "StockContainer",
    "StockText",
    "PriceContainer",
    "SalePrice",
    "SlashedPrice",
    "AppliedPrice",
    "Title",
    "QuantitySelector",
    "AddToCartButton",
  ]
} as const satisfies Record<keyof ThemeFullSections, readonly string[]>;

type Breakpoint = "xs"| "sm"| "md"| "lg"| "xl"| "2xl"| "3xl"| "4xl"| "5xl"| "6xl"| "7xl"| "8xl"| "9xl";

export const breakpoints: Array<Breakpoint> = [
  "xs","sm","md","lg","xl","2xl","3xl","4xl","5xl","6xl","7xl","8xl","9xl"
];

export const weightMap: Record<string, string> = {
  "thin": "100",
  "extralight": "200",
  "light": "300",
  "normal": "400",
  "medium": "500",
  "semibold": "600",
  "bold": "700",
  "extrabold": "800",
  "black": "900",
};

export const spacingMap: Record<string, string> = Array(100).fill(null).reduce((obj, _null, index) => {
  obj[String(index + 1)] = `${(index + 1) * .25}rem`;
  return obj;
}, {} as Record<string, string>);

export const sizeMap: Record<Breakpoint, string> = {
  "xs": "0.75rem",
  "sm": "0.875rem",
  "md": "1rem",
  "lg": "1.125rem",
  "xl": "1.25rem",
  "2xl": "1.5rem",
  "3xl": "1.875rem",
  "4xl": "2.25rem",
  "5xl": "3rem",
  "6xl": "3.75rem",
  "7xl": "4.5rem",
  "8xl": "6rem",
  "9xl": "8rem",
};

// TODO? Make this !important
export const cssUtilityMappings: CSSUtilityMapping[] = [
  { cssProperty: "FontWeight", prefix: "font" },
  { cssProperty: "FontSize", prefix: "text-[length" },
  { cssProperty: "Color", prefix: "text-[color" },
  { cssProperty: "FontFamily", prefix: "font-[family-name" },
  { cssProperty: "BorderTopWidth", prefix: "border-t-[length", direction: "Top" },
  { cssProperty: "BorderBottomWidth", prefix: "border-b-[length", direction: "Bottom" },
  { cssProperty: "BorderLeftWidth", prefix: "border-l-[length", direction: "Left" },
  { cssProperty: "BorderRightWidth", prefix: "border-r-[length", direction: "Right" },
  { cssProperty: "BorderColor", prefix: "border-[color" },
  { cssProperty: "BackgroundColor", prefix: "bg" },
  { cssProperty: "Height", prefix: "h" },
  { cssProperty: "Width", prefix: "w" },
  { cssProperty: "LineHeight", prefix: "leading" },
  { cssProperty: "Gap", prefix: "gap" },
  { cssProperty: "GridTemplateColumns", prefix: "grid-cols" },
  { cssProperty: "ZIndex", prefix: "z" },
  { cssProperty: "PaddingTop", prefix: "pt", direction: "Top" },
  { cssProperty: "PaddingRight", prefix: "pr", direction: "Right" },
  { cssProperty: "PaddingBottom", prefix: "pb", direction: "Bottom" },
  { cssProperty: "PaddingLeft", prefix: "pl", direction: "Left" },
  { cssProperty: "MarginTop", prefix: "mt", direction: "Top" },
  { cssProperty: "MarginRight", prefix: "mr", direction: "Right" },
  { cssProperty: "MarginBottom", prefix: "mb", direction: "Bottom" },
  { cssProperty: "MarginLeft", prefix: "ml", direction: "Left" },
  { cssProperty: "BorderTopLeftRadius", prefix: "rounded-tl", direction: "TopLeft" },
  { cssProperty: "BorderTopRightRadius", prefix: "rounded-tr", direction: "TopRight" },
  { cssProperty: "BorderBottomLeftRadius", prefix: "rounded-bl", direction: "BottomLeft" },
  { cssProperty: "BorderBottomRightRadius", prefix: "rounded-br", direction: "BottomRight" },
  { cssProperty: "BorderTopWidth", prefix: "border-t", direction: "Top" },
  { cssProperty: "BorderRightWidth", prefix: "border-r", direction: "Right" },
  { cssProperty: "BorderBottomWidth", prefix: "border-b", direction: "Bottom" },
  { cssProperty: "BorderLeftWidth", prefix: "border-l", direction: "Left" },
];

  export const defaultInterpreter = "spacing";
